var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlecheR(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "mainStroke",
    id: "rep\\xE8re",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill-rule: evenodd;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m27.89,17.24c-.29.11-.5.39-.5.68,0,.27.2.49,3.06,3.36l3.06,3.07h-9.51c-9.07,0-9.52,0-9.7.15-.27.22-.27.82,0,1.03.18.15.63.15,9.7.15h9.51l-3.06,3.07c-2.86,2.87-3.06,3.09-3.06,3.36,0,.54.57.87,1.02.58.15-.09,1.89-1.79,3.87-3.78,3.35-3.36,3.6-3.63,3.6-3.9s-.25-.53-3.52-3.82c-1.94-1.94-3.67-3.64-3.85-3.77-.33-.24-.41-.27-.63-.18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlecheR);
export default __webpack_public_path__ + "static/media/fleche-r.f9ee881c945329da099efd4813847d0d.svg";
export { ForwardRef as ReactComponent };